import { Controller } from "react-hook-form";
import "./element.scss";
import InfoCard from "../../../info-card/info-card";


interface DynamicInfoProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  value?: any;
  type?: string;
}

const DynamicInfo = (props: DynamicInfoProps) => {
  return (
    <Controller
      control={props.formControl}
      name={`${props.fieldArrayName}.${props.name}`}
      render={({ field }) => (
        <InfoCard
          {...field}
          dataPosition={props.position}
          dataName={`${props.fieldArrayName}.${props.name}`}
          label={props.label}
          value={props.defaultValue || "Info"}
        />
      )}
    />
  );
};
export { DynamicInfo };
export default DynamicInfo;
